(function () {

  'use strict';

  eclipseApp.factory('usageService', ['$http', function($http ) {
          var _usageDataRaw = null;
          var _usageData = null;
          var limitLow = 75;
          var limitHigh = 100;

          function usageServiceGlobalDataSets(masterSet) {
					var globalDisplayTotal = 0;
					var globalDisplayUsed = 0;
					var globalDisplayRemain = 0;
					var globalDisplayOverage = 0;
					var globalPercentage = 0;
					var globalColor = '';

					var globalOnlyExtras = true;
					var globalHaveExtras = false;
					var globalOverExtras = false;

					var globalUnlimitedShow = false;
					var globalUnlimitedClass = 'normal';
//					var globalNotice = '';

					var returnValue = false;
					if (masterSet.length > 0) {
						// Display yes
						returnValue = true;
					} else {
						// Display no
						returnValue = false;
					}

					// Process data
					if (returnValue) {
						// Look through all sets and collect flags that span across entire set
						var sumHaveExtras = false;
						var sumOnlyExtras = true;
						var sumOverExtras = false;

						for (var i = 0; i < masterSet.length; i++) {
							var subSet = masterSet[i];

							if (subSet.haveExtras === true) {
								sumHaveExtras = true;
							}
							if (subSet.onlyExtras === false) {
								sumOnlyExtras = false;
							}
							if (subSet.overExtras === true) {
								sumOverExtras = true;
							}
						}

						// Decide which to select - pick the first set of data - as it is assumed that it has the highest priority
						var largeSet = null;
						if (sumOnlyExtras === true) {
							// Pick the first one
							largeSet = masterSet[0];
						} else {
							if (sumHaveExtras === true) {
								// Find first index that is not pay-per-use
								var outIndex = 0;

								for (var j = 0; j < masterSet.length; j++) {
									var tempSet = masterSet[j];

									if (tempSet.onlyExtras === false) {
										outIndex = j;
										break;
									}
								}

								largeSet = masterSet[outIndex];
							} else {
								// no extras -> pick the first one
								largeSet = masterSet[0];
							}
						}

						// Show the extras badge if there one or more plans has over-usage
						if(sumOverExtras === true) {
							// do something with this information
							sumHaveExtras = true;			// should user have over usage - it will show as extra badge
						}

						if (typeof largeSet === 'object') {

							// This would be a great place to add more logic if required
							globalDisplayTotal = largeSet.displayTotal;
							globalDisplayUsed = largeSet.displayUsed;
							globalDisplayRemain = largeSet.wirelessUsageSummaryInfoList[0].remaining;
							globalDisplayOverage = largeSet.wirelessUsageSummaryInfoList[0].overage;
							globalPercentage = largeSet.highestPercentage;
							globalColor = largeSet.highestColor;

							globalOnlyExtras = sumOnlyExtras;
							globalHaveExtras = sumHaveExtras;
							globalOverExtras = sumOverExtras;

							globalUnlimitedShow = largeSet.unlimitedShow;
							globalUnlimitedClass = largeSet.unlimitedClass;

							// Color definition
//							if (globalPercentage < limitLow) {
//								globalNotice = 'Looking good';
//							} else if (globalPercentage >= limitLow && globalPercentage < limitHigh) {
//								globalNotice = 'Check it out';
//							} else if (globalPercentage >= limitHigh) {
//								globalNotice = 'Extra Usage';
//							}
						}

						// Add data to master set
						masterSet.globalDisplayTotal = globalDisplayTotal;
						masterSet.globalDisplayUsed = globalDisplayUsed;
						masterSet.globalDisplayRemain = globalDisplayRemain;
						masterSet.globalDisplayOverage = globalDisplayOverage;
						masterSet.globalPercentage = globalPercentage;
						masterSet.globalColor = globalColor;

						masterSet.globalOnlyExtras = globalOnlyExtras;
						masterSet.globalHaveExtras = globalHaveExtras;
						masterSet.globalOverExtras = globalOverExtras;

						masterSet.unlimitedShow = globalUnlimitedShow;
						masterSet.unlimitedClass = globalUnlimitedClass;
//						masterSet.globalNotice = globalNotice;
					}

					return returnValue;
				}

          function usageServiceObjectPush(master, tmpObj, groupType) {

              var myCount = 0;

					if (typeof tmpObj === 'object') {
						// Look through the data and pluck specific data from usageSummary array.
						if (tmpObj.wirelessUsageSummaryInfoList.length > 0) {
							for (var u=(tmpObj.wirelessUsageSummaryInfoList.length-1); u>=0; u--) {
								if (typeof tmpObj.wirelessUsageSummaryInfoList[u] === 'object') {
									// this usage set IS and EXTRA and there is no usage meaning that user has ZERO use
									if(tmpObj.wirelessUsageSummaryInfoList[u].total === 0 && tmpObj.wirelessUsageSummaryInfoList[u].othersUsage === 0 && tmpObj.wirelessUsageSummaryInfoList[u].subscriberUsage === 0 && tmpObj.wirelessUsageSummaryInfoList[u].used === 0) {
										// extra  ->  total = 0, othersUsage = 0, subscriberUsage = 0, used = 0
										tmpObj.wirelessUsageSummaryInfoList.splice(u, 1);
									}
								}
							}
						}

						// Push usages into next set that assesses the data and further decorates them.
						if (tmpObj.wirelessUsageSummaryInfoList.length > 0) {
							tmpObj = usageServiceAddData(tmpObj, groupType);
							master.push(tmpObj);

							// handle - status code 103 exception
							if (parseInt(tmpObj.statusCode) === 103) {
								myCount = -1000;
							} else {
								myCount = tmpObj.wirelessUsageSummaryInfoList.length;		// pass this back for proper plan counter
							}
						}
					}

					return myCount;
          }

          // Process and andd some data into the object
          function usageServiceAddData(tmpObj, groupType) {

              var locSet = tmpObj.wirelessUsageSummaryInfoList;
              var highestPercentage = 0;
              var highestColor = '';
              var displayTotal = 0;
              var displayUsed = 0;
              var haveExtras = false;
              var onlyExtras = true;
              var overExtras = false;

              var unlimitedFlag = true;
              var collect = true;
              var collectType = '';
              var collectIndex = -1;

              for (var i in locSet) {
                  var subSet = locSet[i];

                  if (typeof subSet === 'object') {

                      // unlimited / pay-per-use / limited Definitions
                      var locTotal = parseFloat(subSet.total);
                      var locUNLflag = subSet.isUsageUnlimited;

                      if (locTotal < 0) {
                          //		  unlimited -> subSet.total < 0
                          subSet.usageType = 'unlimited';
                          subSet.total = 0;
                          subSet.percentage = 0;
                          subSet.usageColor = 'usageNormal';
                          subSet.overExtra = false;

                          // no plan but extras only
                         onlyExtras = false;


                      } else if (locTotal === 0) {
                          //		pay-per-use -> subSet.total = 0
                          subSet.usageType = 'pay-per-use';
                          subSet.total = 0;
                          subSet.percentage = 100;
                          subSet.usageColor = 'usageNormal';
                          subSet.overExtra = false;

                          // Show dial/meter flag
                          haveExtras = true;


                          // Collect data for dial/meter
                          if (collectType === '') {
                              collectType = subSet.usageType;
                              collectIndex = i;
                          }

                      } else if (locTotal > 0) {
                          //		    limited -> subSet.total > 0
                          subSet.usageType = 'limited';
                          // no plan but extras only
                          onlyExtras = false;

                          // Calculate percentages and if usage is
                          if (groupType === "data"){
                            if (subSet.remaining != 0 || (subSet.remaining == 0 && subSet.overage == 0)) {
                              var percentageTemp = 100 - ((parseFloat(subSet.remaining) / parseFloat(subSet.total)) * 100);
                              subSet.percentage = Math.ceil(percentageTemp);
                            }
                            if (subSet.remaining == 0 && subSet.overage != 0) {
                              subSet.percentage = 101;
                            }
                          }
                          else {
                            var percentageTemp = (parseFloat(subSet.used) / parseFloat(subSet.total)) * 100;
                            subSet.percentage = Math.ceil(percentageTemp);
                          }
                          // Color definition
                          if (subSet.percentage <= 100) {
                              subSet.overExtra = false;
                              subSet.usageColor = 'usageNormal';
                          } else if (subSet.percentage > 100) {
                              subSet.usageColor = 'usageOver';
                              subSet.percentage = 100;
                              subSet.overExtra = true;
                              overExtras = true;
                          }

                          // Show dial/meter flag
                          unlimitedFlag = false;

                          // Collect data for dial/meter
                          if ((collectType === '' || collectType === 'pay-per-use') && collect) {
                              collect = false;
                              collectType = subSet.usageType;
                              collectIndex = i;
                          }

                      }
                      if (parseFloat(subSet.remaining) <= 0) {
                          subSet.remaining = 0;
                      }

                      // Push it back
                      locSet[i] = subSet;
                  }
              }

              // Decide what color and numbers go to the dial at the top
              if (collectIndex >= 0) {
                  // limited or pay-per-use
                  displayTotal = locSet[collectIndex].total;
                  displayUsed = locSet[collectIndex].used;
                  highestColor = locSet[collectIndex].usageColor;
                  highestPercentage = locSet[collectIndex].percentage;

              } else {
                  // unlimited
                  displayTotal = 0;
                  displayUsed = 0;
                  highestColor = 'usageNormal';
                  highestPercentage = 0;
              }

              // Hand-off to level up object
              tmpObj.displayTotal = displayTotal;
              tmpObj.displayUsed = displayUsed;
              tmpObj.highestPercentage = highestPercentage;
              tmpObj.highestColor = highestColor;
              tmpObj.wirelessUsageSummaryInfoList = locSet;
              tmpObj.haveExtras = haveExtras;
              tmpObj.onlyExtras = onlyExtras;
              tmpObj.overExtras = overExtras;

              // Default display type ( normal = round dial at the top / unlimited = no dial, only name and open link )
              tmpObj.unlimitedShow = false;
              tmpObj.unlimitedClass = 'normal';

              // Only if all plans within are unlimited -> switch display type to unlimited
              if (groupType === 'roaming') {
                  tmpObj.unlimitedShow = true;
                  tmpObj.unlimitedClass = 'unlimited';
              } else {
                  if (unlimitedFlag) {
                      tmpObj.unlimitedShow = true;
                      tmpObj.unlimitedClass = 'unlimited';
                  }
              }

              return tmpObj;
          }

				function usageServiceSeparateUsage(masterSet, groupType, countChk) {
					var newMasterSet = {};
					newMasterSet.plans = [];
					newMasterSet.sumary = {};
					newMasterSet.extras = [];
					var newMasterArray = [];

					// split data by type plan (regular/unlimited) and extras
					for (var j in masterSet) {
						var tmpObj = masterSet[j];

						for (var u in tmpObj.wirelessUsageSummaryInfoList) {
							var tmpItem = tmpObj.wirelessUsageSummaryInfoList[u];

							if (typeof tmpItem === 'object') {
								if (tmpItem.usageType === 'pay-per-use') {
									newMasterSet.extras.push(tmpItem);
								} else {
									newMasterSet.plans.push(tmpItem);
								}
							}
						}
					}

					// collect all extras headlines and total values
					if (newMasterSet.extras.length > 0) {
						newMasterSet.sumary.usageType = 'extras_summary';
						newMasterSet.sumary.usageSets = [];

						for (var b = 0; b < newMasterSet.extras.length; b++) {
							var tmpArr = newMasterSet.extras[b];

							// header replace "/" with " / " for better breaking purposes
							var sourceHead = tmpArr.periodGroup;
							var cleanHeadline = sourceHead.replace('/', ' / ');

							var stuffObj = {};
							stuffObj.othersUsage = tmpArr.othersUsage;
							stuffObj.overage = tmpArr.overage;
							stuffObj.periodGroup = cleanHeadline;
							stuffObj.remaining = tmpArr.remaining;
							stuffObj.subscriberUsage = tmpArr.subscriberUsage;
							stuffObj.total = tmpArr.total;
							stuffObj.used = tmpArr.used;
							stuffObj.usageSummaryType = tmpArr.usageSummaryType;

							newMasterSet.sumary.usageSets.push(stuffObj);
						}
					}

					// re-assable the data into new array in this order - Plans > extras summary > extras
					if (newMasterSet.plans.length > 0) {
						for (var t = 0; t < newMasterSet.plans.length; t++) {
							var aaArr = newMasterSet.plans[t];
							newMasterArray.push(aaArr);
						}
					}
					if (newMasterSet.extras.length > 0) {
						// sumary
						newMasterArray.push(newMasterSet.sumary);

						// extras
						for (var e = 0; e < newMasterSet.extras.length; e++) {
							var ccArr = newMasterSet.extras[e];

							if (groupType === 'roaming') {
								// roamig data are always cinsidered an extras
								newMasterArray.push(ccArr);
							} else {
								// extras for all other plans after collecting sumary is pointless -> don't push to display pipe
								// newMasterArray.push(ccArr);
							}
						}


						// roaming data also need to be separated into type buckets - data voice text

					}

					return newMasterArray;
				}

          return {
              // Usage data handling
              getUsageDetails: function( data , callback) {
                  var _return = {};

                    if(data) {
                     										_usageDataRaw = data;

                     										// preset defaults
                     										_usageData = {};
                     										_usageData.data = [];
                     										_usageData.talk = [];
                     										_usageData.text = [];
                     										_usageData.roaming = [];

                     										var dataCounter = {};
                     										dataCounter.data = 0;
                     										dataCounter.talk = 0;
                     										dataCounter.text = 0;
                     										dataCounter.roaming = 0;


                     										// Filter out objects that have no usage information
                     										var tmpObj = {};
                     										var i, j, k, l;
                     										var setCounter = 0;

                     										if (_usageDataRaw.data) {
                     											// Data
                     											for (i in _usageDataRaw.data) {
                     												tmpObj = _usageDataRaw.data[i];
                     												var dadat = usageServiceObjectPush(_usageData.data, tmpObj, 'data');
                     												dataCounter.data += dadat;
                     												setCounter += dadat;
                     											}
                     											if (dataCounter.data > 0) {
                     												_usageData.data.dataArr = usageServiceSeparateUsage(_usageData.data, 'data', dataCounter.data);
                     											}
                     										}

                     										if (_usageDataRaw.talk) {
                     											// Talk
                     											for (l in _usageDataRaw.talk) {
                     												tmpObj = _usageDataRaw.talk[l];
                     												var datal = usageServiceObjectPush(_usageData.talk, tmpObj, 'talk');
                     												dataCounter.talk += datal;
                     												setCounter += datal;
                     											}
                     											if (dataCounter.talk > 0) {
                     												_usageData.talk.dataArr = usageServiceSeparateUsage(_usageData.talk, 'talk', dataCounter.talk);
                     											}
                     										}

                     										if (_usageDataRaw.text) {
                     											// TEXT
                     											for (k in _usageDataRaw.text) {
                     												tmpObj = _usageDataRaw.text[k];
                     												var datext = usageServiceObjectPush(_usageData.text, tmpObj, 'text');
                     												dataCounter.text += datext;
                     												setCounter += datext;
                     											}
                     											if (dataCounter.text > 0) {
                     												_usageData.text.dataArr = usageServiceSeparateUsage(_usageData.text, 'text', dataCounter.text);
                     											}
                     										}

                     										if (_usageDataRaw.roaming) {
                     											// Roamiong
                     											for (j in _usageDataRaw.roaming) {
                     												tmpObj = _usageDataRaw.roaming[j];
                     												var darom = usageServiceObjectPush(_usageData.roaming, tmpObj, 'roaming');
                     												dataCounter.roaming += darom;
                     												setCounter += darom;
                     											}
                     											if (dataCounter.roaming > 0) {
                     												_usageData.roaming.dataArr = usageServiceSeparateUsage(_usageData.roaming, 'roaming', dataCounter.roaming);
                     											}
                     										}

// not sure of the requirement
                     										if (setCounter < 0) {
                     											// statusCode: "103" exeption
                     											_return.midCycle = true;
                     											_return.empty = false;

                     										} else if (setCounter === 0) {
                     											_return.midCycle = false;
                     											_return.empty = true;
                     										} else {
                     											_return.midCycle = false;
                     											_return.empty = false;
                     										}

                     										_return.result = 'success';
                     										_return.data = _usageData;
                     										return callback(_return);

                     									} else {
                     										// Fail and display error message
                     										// {'errorCode':10402,'errorMessage':'failed to get account details'}
                     										_usageData = null;
                     										_return.result = 'fail';
                     										_return.data = data;
                     										_return.empty = true;
                     										_return.midCycle = false;
                     										return callback(_return);
                     									}

                  },

              globalDataSets: function(masterSet) {
                  var returnCatch = false;
                  returnCatch = usageServiceGlobalDataSets(masterSet);
                  return returnCatch;
              }
          };

      }]);



})();
